import Utils from '@/common/utils/utils';
import { TextField } from '@material-ui/core';
import React from 'react';
import { validateInvidualInputs } from '../EditOrganizationHandler';
import PropsType from 'prop-types';
import Constant from '@/common/constant/Constant';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CorporationInvidualBasicSetting({
    listInvidualBasic,
    setListInvidualBasic,
    setIsEdit,
    corpActiveIsBlock,
    listProvideFunction
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const setValInvidualBasic = (val, index, eventBlur = false, label = '') => {
        const cloneListInvidual = [...listInvidualBasic];
        const item = cloneListInvidual[index];
        item.value = val;
        if (eventBlur) {
            item.error = validateInvidualInputs(val, label);
        }

        return cloneListInvidual;
    }

    const handleOnChangeInput = (e, index) => {
        const val = e.target.value;
        setListInvidualBasic(setValInvidualBasic(val, index));
        setIsEdit(true);
    };

    const handleOnBlurInput = (e, index, label) => {
        let val = e.target.value;
        
        setListInvidualBasic(setValInvidualBasic(val, index, true, label));
    }

    if (Utils.isEmptyArray(listInvidualBasic)) return null;

    const isDisplayInvidualBasicSetting = (invidualLabel = '') => {
        let isDisplay = true;

        if (
            invidualLabel ===
            Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_EXTERNAL_WEB_API
        ) {
            // comment for now
            // out of scope. it will be used in next sprints.
            // const settingExternalAPI = listProvideFunction?.find(
            //     item =>
            //         item.label ===
            //         Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_BASIC_EXTERNAL_WEB_API
            // );
            // isDisplay = !!settingExternalAPI?.switchCorporation;
            
            isDisplay = false;
        }
        
        return isDisplay;
    };

    return (
        <>
            <p className="desc-invidual-guidline">
                {tr('バージョンで設定されている値にここで設定した値がプラスされます。')}
            </p>
            {listInvidualBasic?.map((invidual, index) => {
                return (
                    isDisplayInvidualBasicSetting(invidual?.label) && (
                        <>
                            <div className="item-invidual" key={index}>
                                <div className="label">{trI18n(invidual.label)}</div>
                                <div>
                                    <TextField
                                        className="form-control-input form-control-wrapInput form-control-hg32 setting-input"
                                        variant="outlined"
                                        disabled={invidual?.disabled || corpActiveIsBlock}
                                        value={invidual?.value}
                                        onChange={e => handleOnChangeInput(e, index)}
                                        onBlur={e => handleOnBlurInput(e, index, invidual.label)}
                                        helperText={invidual?.error}
                                        error={!Utils.isEmptyString(invidual?.error)}
                                    />
                                    <span>{invidual.unit}</span>
                                </div>
                            </div>
                        </>
                    )
                );
            })}
        </>
    );
}

CorporationInvidualBasicSetting.propTypes = {
    listInvidualBasic: PropsType.any,
    setListInvidualBasic: PropsType.any,
    setIsEdit: PropsType.any,
    corpActiveIsBlock: PropsType.any,
    listProvideFunction: PropsType.any
};